import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import SubscriptionPopup from "./SubscriptionPopup";
import { getMembership } from "../../api/api";
import CustomChat from "../CustomChat";
import { useAuthStore } from "../CustomChat/store/useAuthStore";
import { useChatStore } from "../CustomChat/store/useChatStore";

function Chat() {
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { connectSocket, disconnectSocket } = useAuthStore();
  const { getUsers, setSelectedUser, upsertConversation } = useChatStore();

  useEffect(() => {
    connectSocket();
    const loadChats = async () => {
      await getUsers();
      const conversation = location.state?.conversation;
      if (conversation) {
        upsertConversation(conversation);
        setSelectedUser(conversation);
      }
    };
    loadChats();

    return () => disconnectSocket();
  }, [
    connectSocket,
    disconnectSocket,
    getUsers,
    location.state,
    setSelectedUser,
    upsertConversation,
  ]);

  useEffect(() => {
    checkSubscription();
  }, []);

  const checkSubscription = async () => {
    try {
      const response = await getMembership();
      if (response && response.status >= 200 && response.status <= 300) {
        if (response?.data?.is_membership) {
          handleClose();
        } else {
          handleOpen();
        }
      }
    } catch (error) {
      handleClose();
      // toast.error(
      //   error?.response?.data?.error?.message || "Something wend wrong",
      //   {
      //     position: "top-right",
      //     autoClose: 1500,
      //     theme: "colored",
      //     transition: Zoom,
      //   }
      // );
    }
  };

  return (
    <Box
      height={{ xs: "calc(100vh - 140px)", md: "calc(100vh - 130px)" }}
      minHeight={420}
    >
      {open ? (
        <SubscriptionPopup open={open} handleClose={handleClose} />
      ) : (
        <CustomChat />
      )}
    </Box>
  );
}

export default Chat;
